import { GetComisionAlcanceAnualidad } from "../../../reducers/comisionAnualidad";

export interface ConfiguracionAlcancesStore
  extends GetComisionAlcanceAnualidad {}

export const configuracionAlcancesStore: (
  state
) => ConfiguracionAlcancesStore = state => {
  const comisionAnualidad = state.comisionAnualidad;

  return {
    comisionesAlcanceAnualidad: comisionAnualidad.comisionesAlcanceAnualidad,
    gettingComisionesAlcanceAnualidad:
      comisionAnualidad.gettingComisionesAlcanceAnualidad,
    gettingComisionesAlcanceAnualidadError:
      comisionAnualidad.gettingComisionesAlcanceAnualidadError
  };
};
